var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgOffers = function SvgOffers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f8fa4",
    d: "M7.926 23.067a2.513 2.513 0 01-.418-.324 2.418 2.418 0 01-.754-1.758v-8.187a.54.54 0 01.26-.46l3.122-1.883a.553.553 0 01.519-.027.536.536 0 01.307.413l.578 4.165a.575.575 0 01.005.058l.175 5.848c.02.654-.22 1.277-.675 1.753a2.485 2.485 0 01-1.734.769 2.488 2.488 0 01-1.385-.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ebfd5",
    d: "M12 15.072H4.91c-2.708 0-4.91-2.173-4.91-4.845 0-2.671 2.202-4.844 4.91-4.844H12c.301 0 .545.24.545.538v8.612a.542.542 0 01-.545.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M22.364 20.455a.55.55 0 01-.265-.068L12 15.072v-9.69L22.099.069a.55.55 0 01.541.006.537.537 0 01.27.464v19.378a.536.536 0 01-.27.464.55.55 0 01-.276.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f8fa4",
    d: "M23.455 20.455h-1.091a.542.542 0 01-.546-.539V.538c0-.297.244-.538.546-.538h1.09c.302 0 .546.24.546.538v19.378a.542.542 0 01-.545.539z"
  }))));
};
export default SvgOffers;